import React, { useEffect, useRef, useState } from 'react';
import { X, Settings, Layers, Box, Package, Check, Info } from 'lucide-react';
import { updateInventorySettings } from '../services/auth';
export default function InventorySettingsModal({ user, onClose, onSaved }) {
  const [level, setLevel] = useState(user?.inventory_measurement_level || 'Carton');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const ref = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    ref.current?.querySelector('input:checked')?.focus();
    const handler = event => {
      if (event.key === 'Escape' && !busy) onClose();
      if (event.key === 'Tab') {
        const controls = [...ref.current.querySelectorAll('button:not(:disabled), input:not(:disabled)')];
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', handler);
    return () => { document.removeEventListener('keydown', handler); previous?.focus(); };
  }, [busy, onClose]);
  async function save(event) {
    event.preventDefault(); setBusy(true); setError('');
    try { await updateInventorySettings(level); onSaved(); }
    catch (err) { setError(err.message); setBusy(false); }
  }
  return <div className="app-password-backdrop" onMouseDown={event => { if (event.target === event.currentTarget && !busy) onClose(); }}>
    <div className="app-password-modal inventory-settings-modal" role="dialog" aria-modal="true" aria-labelledby="inventory-settings-title" ref={ref}>
      <div className="app-password-heading"><div className="inventory-settings-title"><span className="inventory-settings-title-icon"><Settings size={18} /></span><div><h2 id="inventory-settings-title">Inventory Settings</h2><span>Choose how inventory totals are calculated</span></div></div><button aria-label="Close inventory settings" onClick={onClose} disabled={busy}><X size={19} /></button></div>
      <form onSubmit={save}>
        <fieldset disabled={busy} className="inventory-settings-options"><legend>Calculate CBM and weights from</legend>
          {[['Pallet', Layers, 'Pallet totals'], ['Carton', Box, 'Carton totals'], ['Product', Package, 'Product totals']].map(([value, Icon, description]) => <label key={value} className={`inventory-settings-option${level === value ? ' selected' : ''}`}>
            <input type="radio" name="measurement-level" aria-label={value === 'Carton' ? 'Cartons' : value} value={value} checked={level === value} onChange={() => setLevel(value)} />
            <Icon size={22} className="inventory-settings-option-icon" aria-hidden="true" />
            <strong>{value === 'Carton' ? 'Cartons' : value}</strong><span>{description}</span>
            <span className="inventory-settings-check" aria-hidden="true">{level === value && <Check size={12} />}</span>
          </label>)}
        </fieldset>
        <div className="inventory-settings-info"><Info size={16} aria-hidden="true" /><div><strong>{level === 'Carton' ? 'Carton' : level} measurements are required</strong><p>Enter CBM, net weight and gross weight at this level. Measurements at other levels are optional.</p></div></div>
        <p className="inventory-settings-scope">Applies to new inventory only. Existing records keep their saved calculation level. Container selection keeps whole cartons.</p>
        {error && <p role="alert" className="wh-form-error">{error}</p>}
        <div className="app-password-actions"><button type="button" onClick={onClose} disabled={busy}>Cancel</button><button type="submit" disabled={busy}>{busy ? 'Saving...' : 'Save Changes'}</button></div>
      </form>
    </div>
  </div>;
}
